/* Briques communes à l'Accueil et à sa section Nouveautés (2026-09-16,
   réduites le 2026-10-01 avec la refonte de l'Accueil). */

/* Libellé du module d'une nouveauté (clés de `platform_news`). */
export const NEWS_LABELS = {
  people: 'People', finance: 'Finance', sales: 'Ventes & Opérations', planning: 'Planification',
  analytics: 'Analytique Services', cockpit: 'Cockpit', general: "Toute l'app",
};

/* Ouvrir UNE nouveauté depuis l'Accueil (2026-10-01) : la section Nouveautés
   s'ouvre sur elle, dépliée. Le relais passe par la mémoire de session, la
   page ne recevant pas de paramètre ; il se lit une fois, puis s'efface. */
const NEWS_OPEN_KEY = 'palestre_news_open';
export function openNews(id, setPage) {
  try { sessionStorage.setItem(NEWS_OPEN_KEY, id); } catch (e) { /* mémoire indisponible */ }
  if (setPage) setPage('welcome-news');
}
export function takeOpenNews() {
  try {
    const id = sessionStorage.getItem(NEWS_OPEN_KEY);
    sessionStorage.removeItem(NEWS_OPEN_KEY);
    return id;
  } catch (e) { return null; }
}

export function fmtDate(iso, long = false, withYear = false) {
  if (!iso) return '';
  const d = new Date(`${String(iso).slice(0, 10)}T00:00:00`);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString('fr-CH', long
    ? { day: 'numeric', month: 'long', ...(withYear ? { year: 'numeric' } : {}) }
    : { day: '2-digit', month: 'short' });
}
